module.exports = __webpack_public_path__ + "static/media/faq_register.ccfd486c.svg";